import React, { useEffect } from "react";
import { useQuery, gql } from "@apollo/client";
import {
  Switch,
  Route,
  Link,
  useParams,
  useRouteMatch,
} from "react-router-dom";
import { parseShowDate, parseShowTime } from "../libraries/time.jsx";

const Venue = (props) => {
  let { venueId } = useParams();
  useEffect(() => {
    props.setSelectedVenue(venueId);
  });

  const FIND_VENUE = gql`
  {
  findVenueByID (id: ${venueId}) {
    _id
    name
    address
    thumbnail
    shows {
      data {
        _id
        name
        start_time
        end_time
        thumbnail
      }
    }
  }
}
`;
  const { data, loading, error } = useQuery(FIND_VENUE);
  if (loading) {
    return <div className="glass w-full h-24 animate-pulse"></div>;
  }
  if (error) return `Error! ${error}`;
  let venueData = data.findVenueByID;
  let nextShow = venueData.shows.data[0];

  let moreShowsCard;
  if (venueData.shows.data.length > 1) {
    moreShowsCard = (
      <li className="glass overflow-hidden rounded-md px-2">
        + {venueData.shows.data.length} more upcoming shows
      </li>
    );
  }

  return (
    <div
      className={`fixed w-full h-fit bottom-0 pb-4 lg:w-1/3 lg:top-20 lg:left-0 fade-in ${
        props.drawerOpen ? "fade-in" : ""
      }`}
    >
      <p className="text-2xl w-full glass px-2">{venueData.name}</p>
      <ul className="space-y-3 mt-2 px-2">
        <li className="glass overflow-hidden rounded-md" key={nextShow._id}>
          <Link className="flex" to={`/events/${nextShow._id}`}>
            <div
              className="w-1/4 rounded-l-md bg-cover bg-center"
              style={{ backgroundImage: `url(${nextShow.thumbnail})` }}
            ></div>
            <div className="px-2 py-1 pb-4">
              <p className="line-clamp-1">{nextShow.name}</p>
              {parseShowDate(nextShow.start_time)}
              <div className="flex">
                {parseShowTime(nextShow.start_time)}{" "}
                <span className="mx-2">-</span>
                {parseShowTime(nextShow.end_time)}
              </div>
            </div>
          </Link>
        </li>
        {moreShowsCard}
      </ul>
    </div>
  );
};

export const VenueShows = (props) => {
  let { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}></Route>
      <Route path={`${path}/:venueId`}>
        <Venue {...props} />
      </Route>
    </Switch>
  );
};
